//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import { createApp } from "vue";
import App from "@/App.vue";
import Store from "@/store";
import HttpClient from "@/../../../common/services/HttpClient.js";
import SocketService from "@/../../../common/services/SocketService";
import ActionsManager from "@/../../../common/services/ActionsManager.js";

import MakeWindowFullScreenActionHandler from "@/../../../common/services/actionsHandlers/MakeWindowFullScreenActionHandler.js";
import RestartSocketActionHandler from "@/../../../common/services/actionsHandlers/RestartSocketActionHandler.js";
import ResetMarkersAndTargetsActionHandler from "@/services/actionsHandlers/ResetMarkersAndTargetsActionHandler.js";
import ModifyClientTargetsActionHandler from "@/services/actionsHandlers/ModifyClientTargetsActionHandler.js";
import CloseWebCompanionActionHandler from "@/services/actionsHandlers/CloseWebCompanionActionHandler.js";

function SetAppStyles({
  backgroundColor = Store.state.Style.backgroundColor,
  themeColor = Store.state.Style.themeColor,
  fontFamily = Store.state.Style.fontFamily,
  zIndex = Store.state.Style.zIndex,
}) {
  Store.state.Style.backgroundColor = backgroundColor;
  Store.state.Style.themeColor = themeColor;
  Store.state.Style.fontFamily = fontFamily;
  Store.state.Style.zIndex = zIndex;
}

function SetInitSessionDetails({ clientId, serverUrl, options, version }) {
  Store.state.Session.clientId = clientId;
  Store.state.Session.serverUrl = serverUrl;
  Store.state.Session.options = options;
  Store.state.Session.appVersion = version;
}

function updateHttpClient(serverUrl, headersDetails = []) {
  if (serverUrl) {
    HttpClient.defaults.baseURL = serverUrl;
  }

  headersDetails.forEach(function (detail) {
    HttpClient.defaults.headers.common[detail.header] = detail.value;
  });
}

async function _setGlobalServices(app, apiClass) {
  await SocketService.connect(
    "wss://" + apiClass.config.appConfig.api_ws,
    Store.state.Session.clientId,
    Store.state.Session.options.profileName
  );
  const webCompanionHandlers = {
    ModifyClientTargetsActionHandler,
    RestartSocketActionHandler,
    ResetMarkersAndTargetsActionHandler,
    MakeWindowFullScreenActionHandler,
    CloseWebCompanionActionHandler,
  };
  app.provide(
    "actionsManager",
    new ActionsManager(apiClass.store, webCompanionHandlers)
  );
  app.provide("api", apiClass);
}

async function mountApp(apiClass) {
  const app = createApp(App);
  await _setGlobalServices(app, apiClass);
  app.use(Store).mount(`#${apiClass.options.containerId}`);
  return app;
}
export { SetAppStyles, SetInitSessionDetails, updateHttpClient, mountApp };
